<template>
  <div style="z-index:99999;">
    <div class="rightBar pc" v-if="navBarFixed">
      <div class="ce">
        <i class="el-icon-plus" style="font-size: 40px"></i>
        <!-- <div>联系我们</div> -->
      </div>
      <div class="main">
        <div class="bar">
          <img src="../assets/weixin.png" alt="" style="height: 30px" />
          <div>微信</div>
          <div class="detail">
            <img src="../assets/ercode.jpg" alt="" style="width: 100%" />
          </div>
        </div>
        <div class="bar" @click="go()">
          <img src="../assets/gh.png" alt="" style="height: 30px" />
          <div>快速挂号</div>
        </div>
        <div class="bar">
          <a href="tel:0769-38803323">
            <img src="../assets/phone1.png" alt="" style="height: 30px" />
            <div style="color: #d5d5d5">电话</div>
          </a>
          <div
            class="detail typeClick"
            @click="copyText"
            id="text"
            title="点击复制电话"
          >
            0769-38803323
          </div>
        </div>
        <div class="bar">
          <i class="el-icon-close" style="font-size: 40px; color: #d0d0d0"></i>
          <!-- <div>联系我们</div> -->
        </div>
      </div>
    </div>
    <div class="top pc" v-if="navBarFixed">
      <a  @click="backtopClick" style="cursor:pointer"
        ><img src="../assets/top.png" alt="" style="height: 50px; width: 50px"
      /></a>
    </div>
    <textarea id="input">测试</textarea>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: "rightBat",
  data() {
    return {
      navBarFixed: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", this.watchScroll);
  },
  methods: {
    backtopClick() {
      $('body,html').animate({scrollTop:0},1000);
      return false;
    },
    go() {
      this.$router.push({
        path: "/yuyue",
        query: {
          id: "yuyuefangshi",
        },
      });
    },
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  当滚动超过 90 时，实现吸顶效果
      if (scrollTop > 90) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    copyText() {
      var text = document.getElementById("text").innerText;
      var input = document.getElementById("input");
      input.value = text; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$notify({
        title: "复制成功",
        type: "success",
      });
      // this.$notify({
      //   message: "复制成功",
      //   type: "success",
      // });
    },
  },
};
</script>

<style>

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active 用于 2.1.8 以下版本 */ {
  transform: translateX(10px);
  opacity: 0;
}
#input {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: -10;
}
.rightBar {
  position: fixed;
  bottom: 150px;
  right: 30px;
  z-index: 9999999999;
  border-radius: 100%;
}
.rightBar .main {
  border-radius: 50px;
}
.rightBar .bar {
  display: none;
  text-align: center;
  padding: 10px 5px;
  background-color: #fff;
  position: relative;
  font-size: 12px;
  color: #d5d5d5;
}
.rightBar .bar:first-child {
  border-radius: 50px 50px 0 0;
  padding-top: 15px;
}
.rightBar .bar:last-child {
  border-radius: 0 0 50px 50px;
  padding-bottom: 15px;
}
.rightBar .ce {
  line-height: 20px;
  background-color: #fff;
  border-radius: 100%;
  display: flex;
  align-items: center;
  padding: 10px;
  color: #d0d0d0;
}
/* .rightBar .ce > div{
    width:40px;
    font-size: 14px;
} */
.rightBar:hover .bar {
  display: block;
}
.rightBar:hover .ce {
  display: none;
}
.rightBar .text {
  font-size: 12px;
}
.rightBar .bar .detail {
  position: absolute;
  display: none;
  justify-content: center;
  align-items: center;
  min-height: 43px;
  font-size: 14px;
  width: 120px;
  padding: 0 20px;
  right: 0;
  top: 0;
  color: #444;
  z-index: -1;
  background-color: #fff;
}
.rightBar .bar:hover .detail {
  display: flex;
  align-items: center;
  right: 63px;
  border: 1px solid #e5e5e5;
  border-right: 0;
  z-index: 0;
}
.top {
  position: fixed;
  bottom: 80px;
  right: 30px;
  padding: 6px;
  transition: all 0.5s;
}
@media screen and (max-width: 750px){
  .top {
    background:#555;
    border-radius: 100%;
    z-index: 9999999;
    transform: scale(0.7);
    bottom: 0.5rem;
    right: 20px 
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rightBar.vue